import login from '@/login/login'
import health from '@/login/healthy'
let router = [
    {
        path: '/health',
        name:'health',
        component: health
    }
]
export default router



// WEBPACK FOOTER //
// ./src/router/login_router.js